import { render, staticRenderFns } from "./VersionIndicator.vue?vue&type=template&id=157a9427&"
import script from "./VersionIndicator.vue?vue&type=script&lang=js&"
export * from "./VersionIndicator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('157a9427')) {
      api.createRecord('157a9427', component.options)
    } else {
      api.reload('157a9427', component.options)
    }
    module.hot.accept("./VersionIndicator.vue?vue&type=template&id=157a9427&", function () {
      api.rerender('157a9427', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/js/src/app/components/header/VersionIndicator.vue"
export default component.exports